import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { getSortOptions } from '../../../utils'
import { useTranslation } from '../../../utils/providers'
import { CustomSelectbox } from '../Form'

function SortDropdown({ queryParams, submitForms }) {
  const { t } = useTranslation()
  const [options, selectedOption] = getSortOptions(queryParams, t)
  const [selectedValue, setSelectedValue] = useState(selectedOption?.value)

  const formData = {
    name: 'sorting',
    value: selectedOption?.value,
  }

  const handleChange = (e) => {
    setSelectedValue(e.target.value)
  }

  useEffect(() => {
    // Avoid requests when there is no actual change
    if (selectedValue !== selectedOption?.value) {
      submitForms({ resetPagination: true })
    }
  }, [selectedValue])

  return (
    <form id="product-list-sort-form" className="product-grid__sorter-form">
      <CustomSelectbox
        className="white-space-nowrap"
        data={formData}
        options={options}
        onChange={handleChange}
        align="right"
        arrowIcon="cf-sort"
      />
      <input type="hidden" name={formData.name} value={selectedValue} />
    </form>
  )
}

SortDropdown.propTypes = {
  queryParams: PropTypes.object.isRequired,
  submitForms: PropTypes.func.isRequired,
}

export default SortDropdown
